<div style="height: 100%; position:relative">
  <cst-card [isLoading]="!facilityID || isLoading" [compact]="true" headerIcon="{{ selectedHeaderIcon }}"
    actionsAlign="end">
    <ng-template cstCardTitle>
      @if (folderVisibility) {
        <span i18n="@@Infoportal_Folders">Folders</span>
      }
      @if (!folderVisibility) {
        <span i18n="@@Infoportal_Documents">Documents</span>
      }
      <span>
        @if (!isConnected) {
          <mat-icon matTooltip="Keine Internetverbindung" style="margin-left: 50px; color: red"
          aria-hidden="false" aria-label="Example home icon">cloud_off</mat-icon>
        }
      </span>
    </ng-template>
    <ng-template cstCardContent>
      <div style="position: relative; max-height: 600px">
        @if (displayFilter) {
          <div>
            <mat-chip-set>
              @for (filter of filtersCombined; track filter) {
                <mat-chip [removable]="filter.onRemove" (removed)="filter.onRemove()"
                  [attr.title]="filter.tooltip ? filter.tooltip : undefined">
                  {{ filter.label | async }}
                  @if (filter.onRemove) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        }

        <cst-folder-document-tree folderSource="facility" documentSource="infoportal"
          [onlyDisplayLeaves]="!folderVisibility" [sortBy]="sortBy" (dataSourceInit)="onDataSourceInit($event)"
          (nodeFocusDataSourceInit)="onNodeFocusDataSourceInit($event)"
          (focusedNodeChanged)="onFocusedNodeChanged($event)"
        (itemChanged)="onItemChanged($event)"/>
      </div>
    </ng-template>
    <ng-template cstCardActions>
      @if (!focusedNode) {
        @if (isFolderCreateVisible) {
          <ctrl-btn [flat]="true" type="primary" icon="create_new_folder"
            i18n-content="@@InfoportalAPI_FolderTreeCard_AddNewFolder" content="New folder" [hidden]="!folderVisibility"
            [disabled]="!userClaims.createProcess || !isConnected" (click)="OnFolderCreate()">
          </ctrl-btn>
        }
        <ctrl-btn [flat]="true" type="default" icon="filter_list" i18n-content="@@InfoportalAPI_FolderTreeCard_Filter"
          content="Filter" [disabled]="!isConnected" (click)="onFilterPopupOpen()">
        </ctrl-btn>
        <ctrl-btn [flat]="true" type="default" icon="refresh" i18n-content="@@InfoportalAPI_FolderTreeCard_Refresh"
          content="Refresh" [disabled]="!isConnected" (click)="onFoldersRefresh()">
        </ctrl-btn>
        <div style="flex: 1 1 auto"></div>
        <ctrl-btn [flat]="true" icon="more_vert" i18n-content="@@InfoportalAPI_FolderTreeCard_More"
          [disabled]="!isConnected" [matMenuTriggerFor]="folderTreeCardMoreMenu">
        </ctrl-btn>
        <mat-menu #folderTreeCardMoreMenu="matMenu">
          <button mat-menu-item (click)="onChangeFolderVisibility(folderVisibility)">
            @if (folderVisibility === true) {
              <mat-icon>folder_off</mat-icon>
              <span i18n="@@InfoportalAPI_FolderTreeCard_HideFolder">Hide folder</span>
            }
            @if (folderVisibility === false) {
              <mat-icon>folder</mat-icon>
              <span i18n="@@InfoportalAPI_FolderTreeCard_UnhideFolder">Unhide folder</span>
            }
          </button>
          <button mat-menu-item [matMenuTriggerFor]="folderTreeCardSortMenu">
            <mat-icon>sort</mat-icon>
            <span i18n="@@InfoportalAPI_FolderTreeCard_SortBy">Sort By</span>
          </button>
        </mat-menu>
        <mat-menu #folderTreeCardSortMenu="matMenu">
          <button mat-menu-item (click)="onProgressSortBy('label')">
            <mat-icon>
              @if (sortBy === 'label_asc') {
                arrow_upward
              }
              @if (sortBy === 'label_desc') {
                arrow_downward
              }
            </mat-icon>
            <!-- <span *ngIf="folderVisibility === true" i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Foldername">Foldername</span>
            <span *ngIf="folderVisibility === false" i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Filename">Filename</span> -->
            <span>
              @if (folderVisibility === true) {
                <ng-container
                i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Foldername">Foldername</ng-container>
              }
              @if (folderVisibility === false) {
                <ng-container
                i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Filename">Filename</ng-container>
              }
            </span>
            <!-- <span i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Label">Label</span> -->
          </button>
          <button mat-menu-item (click)="onProgressSortBy('date')">
            <mat-icon>
              @if (sortBy === 'date_asc') {
                arrow_upward
              }
              @if (sortBy === 'date_desc') {
                arrow_downward
              }
            </mat-icon>
            <span i18n="@@InfoportalAPI_FolderTreeCard_SortBy_ModificationDate">Modification date</span>
            <!-- <span>Änderungsdatum</span> -->
            <!-- <span i18n="@@InfoportalAPI_FolderTreeCard_SortBy_Date">Date</span> -->
          </button>
        </mat-menu>
      }
    </ng-template>
  </cst-card>


  @if (isDownloadingFolder) {
    <div
      style="position: absolute; left:0; top:0; right:0; bottom:0; display: flex; flex-wrap: wrap; align-content: center; justify-content: center; background: #0003; border-radius: 4px">
      <div class="mat-elevation-z8" style="background: white; padding: 20px; border-radius: 20px; display: flex; flex-direction: column; gap: 10px;">
        <span><strong>Dateien werden vorbereitet<br/>und heruntergeladen...</strong></span>
        <ctrl-progress-bar mode="buffer"></ctrl-progress-bar>
      </div>
    </div>
  }
</div>